import { fmt } from "@/lib/format";

const List = ({ title, rows, tone, testid }) => (
  <div data-testid={testid} className="min-w-0 rounded-xl border bg-card p-4 sm:p-5 shadow-sm">
    <h3 className={`font-heading text-base sm:text-lg font-semibold ${tone}`}>{title}</h3>
    <ol className="mt-3 divide-y text-sm">
      {rows.map((r, i) => (
        <li key={`${r.nama}-${r.id_petugas}-${i}`} data-testid={`${testid}-row-${i}`} className="flex items-center gap-3 py-2">
          <span className="w-6 text-xs font-num text-muted-foreground">{i + 1}</span>
          <div className="min-w-0 flex-1">
            <p className="truncate font-medium">{r.nama}</p>
            <p className="truncate text-xs text-muted-foreground">{[r.unit, r.ulp].filter(Boolean).join(" · ")}</p>
          </div>
          <span className={`font-num font-semibold ${tone}`}>{fmt(r.persen, "pct")}</span>
        </li>
      ))}
    </ol>
  </div>
);

export const TopBottomYO = ({ rows, n = 10 }) => {
  const list = (rows || []).filter((r) => r.nama && r.persen != null);
  if (!list.length) return null;
  const k = Math.min(n, Math.ceil(list.length / 2));
  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
      <List testid="yo-top-list" title={`${k} Petugas YO Tertinggi`} rows={list.slice(0, k)} tone="text-emerald-600" />
      <List testid="yo-bottom-list" title={`${k} Petugas YO Terendah`} rows={list.slice(-k).reverse()} tone="text-rose-600" />
    </div>
  );
};
